import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import Form from '@gef-ui/form-material/Form';

import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import { ComponentLoader, Floating } from 'components/index';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { resetErrorsByPage } from 'features/common/submitFormDialog/slice';
import { templateTypes } from 'features/views/campaignSettings/templates/constants';
import formDescriptorFn, { SAVE_TEMPLATE_FORM_NAME } from 'features/views/campaignSettings/templates/form';

import SaveTemplateForm from './SaveTemplateForm';
import TemplateTable from './TemplateTable';

export const LoadSaveTemplateModalBody = ({ campaignDetail, onSuccess, type }) => {
	const dispatch = useDispatch();

	useEffect(
		() => () => {
			dispatch(dialog.actions.close(SAVE_TEMPLATE_FORM_NAME));
			dispatch(resetErrorsByPage({ page: SAVE_TEMPLATE_FORM_NAME }));
		},
		[dispatch],
	);

	return (
		<Stack spacing={3}>
			<Floating>
				<SubmitFormDialog pageName={SAVE_TEMPLATE_FORM_NAME} />
			</Floating>
			{type === templateTypes.SAVE && (
				<Form name={SAVE_TEMPLATE_FORM_NAME} formDescriptorFn={formDescriptorFn}>
					<SaveTemplateForm campaignId={campaignDetail.id} />
				</Form>
			)}
			<ComponentLoader fetchStorePath={fetch.constants.urls.campaignLoadPattern} ignoreErrors>
				<TemplateTable
					campaignId={campaignDetail.id}
					selectable={type === templateTypes.LOAD}
					onSuccess={onSuccess}
				/>
			</ComponentLoader>
		</Stack>
	);
};

LoadSaveTemplateModalBody.propTypes = {
	campaignDetail: PropTypes.object,
	onSuccess: PropTypes.func,
	type: PropTypes.oneOf([templateTypes.LOAD, templateTypes.SAVE]),
};

export default LoadSaveTemplateModalBody;
